import { VhcRecordLogService } from 'api/generated';
import { QueryError, formatErrorMessage } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';
import { toast } from 'react-toastify';

export type DeleteBreakLabourInput = {
  logId: number;
  itemId: number;
  labourId: number;
};

export const useDeleteBreakLabourMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof VhcRecordLogService.deleteVhcRecordsItemsBrakesLabours>>,
      QueryError,
      DeleteBreakLabourInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation(
    ({ logId, itemId, labourId }: DeleteBreakLabourInput) => {
      return VhcRecordLogService.deleteVhcRecordsItemsBrakesLabours(logId, itemId, labourId);
    },
    {
      ...options
    }
  );
